import { MoreHorizOutlined } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import WorkflowSessionModal from "../../ItemProperties/WorkflowSessionModal";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import SmartPasswordField from "../../../commonComponents/SmartPasswordField";
import CustomHeaders from "./HttpCustomHeaders/CustomHeaders";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import {
  decryptString,
  encryption,
  encryptString,
  stringifyJSONAttributes,
  stringToBooleanConversion,
} from "../../../utils/utilFunctions";
import _, { debounce } from "lodash";
import { treeActions } from "../../../redux/slices/treeSlice";
import { graphQLContentTypeOptions } from "../../../constants/constantList";

function GraphQL({
  connectionDetails,
  handleBodyContent,
  connectionName,
  direction,
  account,
  screen,
  disableControl,
  useConnection,
  repoPDC,
  source = "",
}) {
  const shouldEncryptDecryptPassword = String(source || "").toLowerCase() !== "pdc";
  const { t } = useTranslation();
  const [content, setContent] = useState(null);
  const [url, setUrl] = useState("");
  const [requestType, setRequestType] = useState("");
  const [contentType, setContentType] = useState("");
  const [keyAlias, setKeyAlias] = useState('');
  const [keyAliases, setKeyAliases] = useState([]);
  const [privateKey, setPrivateKey] = useState("");
  const [privateKeys, setPrivateKeys] = useState([]);
  const [username, setUsername] = useState("");
  const [valueLabel, setValueLabel] = useState("");
  const [password, setPassword] = useState("");
  const [outTime, setOutTime] = useState("");
  const [sslVersion, setSslVersion] = useState("");
  const [sslVersionsTypeOptions, setSslVersionsTypeOptions] = useState([]);
  const [customHeaders, setCustomHeaders] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [sslHost, setSslHost] = useState(false);
  const [syncResponse, setSyncResponse] = useState(false);
  const [decompression, setDecompression] = useState(false);
  const [compression, setCompression] = useState(false);
  const [urlEncode, setUrlEncode] = useState(false);
  const [showDecompressionDir, setShowDecompressionDir] = useState(false);
  const [decompressionDir, setDecompressionDir] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [decomPassword, setDecomPassword] = useState("");
  const [compressionType, setCompressionType] = useState("");
  const [compressionList, setCompressionList] = useState([]);
  const [fileNameZip, setFileNameZip] = useState("");
  const [destinationPassword, setDestinationPassword] = useState("");
  const [showDestinationPassword, setShowDestinationPassword] = useState(false);
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
  });
  const [showAlert, setShowAlert] = useState({
    mssg: "",
    isOpen: false,
    type: "",
  });
  const dispatch = useDispatch();
  const { rightTree } = useSelector(
    (state) => state.treeData[state.treeData.currentScreen]
  );
  const currentTab = rightTree.currentTab;

  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const connection = useSelector(
    (state) => state?.treeData?.inbound?.connection
  );
  const requestTypesDropDownItems = ['POST', 'GET'].map((obj, key) => (
    <MenuItem key={key} value={obj}>
        {obj}
    </MenuItem>
));
  const workflowMappings = {
    [t("LBL_URL")]: {
      stateSetter: setUrl,
      key: "CONNECTIONSTRING",
      value: url,
    },
    [t("LBL_KEY_ALIAS")]: {
      stateSetter: setPrivateKey,
      key: "KEY_ALIAS",
      value: privateKey,
    },
    [t("LBL_USERNAME")]: {
      stateSetter: setUsername,
      key: "USERNAME",
      value: username,
    },
    [t("LBL_WS_PASSWORD")]: {
      stateSetter: setPassword,
      key: "PASSWORD",
      value: password,
    },
    [t("LBL_ZIP_PASSWORD")]: {
      stateSetter: setDecomPassword,
      key: "ZIP_PASSWORD",
      value: decomPassword,
    },
    [t("LBL_DECOMPRESS_DIRECTORY")]: {
      stateSetter: setDecompressionDir,
      key: "DECOMPRESSION_DIRECTORY",
      value: decompressionDir,
    },
    [t("LBL_KEY_ALIAS_TO_USE")]: {
      stateSetter: setKeyAlias,
      key: "KEY_ALIAS",
      value: keyAlias,
    },
    [t("FILE_NAME_WITHIN_ZIP")]: {
      stateSetter: setFileNameZip,
      key: "FILE_NAME_WITHIN_ZIP",
      value: fileNameZip,
    },
    [t("LBL_ZIP_PASSWORD") + "_DEST"]: {
      stateSetter: setDestinationPassword,
      key: "ZIP_PASSWORD",
      value: destinationPassword,
    },
  };
  useEffect(() => {
    dispatch(api.endpoints.getSslVersion.initiate({ account })).then((res) => {
      if (res?.data?.current_state === "SUCCESS") {
        setSslVersionsTypeOptions(res?.data?.data);
      }
    });
    dispatch(
      api.endpoints.getPrivateKeys.initiate(
        { private_key: true },
        { forceRefetch: true }
      )
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS") {
        setPrivateKeys(res?.data?.data);
      } else setPrivateKeys([]);
    });
    dispatch(api.endpoints.getPrivateKeys.initiate({private_key: false}, { forceRefetch: true })).then((res) => {
        if (res?.data?.current_state === 'SUCCESS') {
            setKeyAliases(res?.data?.data);
        } else setKeyAliases([]);
    })
    if (direction === "OUT") {
      dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
        if (res?.data?.current_state === "SUCCESS") {
          const types = Object.values(res?.data?.data)?.map(
            (item) => item?.TYPE
          );
          setCompressionList(types);
        }
      });
    }
  }, [direction]);

  useEffect(() => {
    setUrl(connectionDetails?.CONNECTIONSTRING);
    setPrivateKey(connectionDetails?.KEY_ALIAS || "");
    setRequestType(connectionDetails?.REQUEST_TYPE || "POST");
    setContentType(connectionDetails?.CONTENT_TYPE || "application/json");
    setKeyAlias(connectionDetails?.KEY_ALIAS || "");
    setUsername(connectionDetails?.USERNAME || "");
    setPassword(
      connectionDetails?.PASSWORD
        ? shouldEncryptDecryptPassword
          ? decryptString(
              connectionDetails?.PASSWORD,
              process.env.REACT_APP_SECRET_KEY2
            )
          : connectionDetails?.PASSWORD
        : ""
    );
    setOutTime(connectionDetails?.TIMEOUT || 600);
    setSslVersion(
      connectionDetails?.SSL_TYPE || connectionDetails?.SSL_TYPE || "TLSv1"
    );
    setSslHost(
      stringToBooleanConversion(connectionDetails?.FORCE_HOST_VERIFICATION) ||
        false
    );
    setSyncResponse(
      stringToBooleanConversion(connectionDetails?.SYNCHRONOUS) || false
    );
    setDecompression(
      stringToBooleanConversion(connectionDetails?.ZIP) || false
    );
    setUrlEncode(
      stringToBooleanConversion(connectionDetails?.URLENCODE) || false
    );
    if (connectionDetails?.ZIP) {
      direction === "IN" ? setDecompression(true) : setCompression(true);
    } else {
      setDecompression(false);
      setCompression(false);
    }
    setShowDecompressionDir(
      (connectionDetails?.DECOMPRESSION_DIRECTORY?.length > 0 ? true : false) ||
        stringToBooleanConversion(
          connectionDetails?.SPECIFY_DECOMPRESSION_DIRECTORY
        )
    );
    setDecompressionDir(connectionDetails?.DECOMPRESSION_DIRECTORY || "");
    setShowPassword(
      stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD) || false
    );
    setDecomPassword(
      connectionDetails?.ZIP_PASSWORD
        ? decryptString(
            connectionDetails?.ZIP_PASSWORD,
            process.env.REACT_APP_SECRET_KEY2
          )
        : ""
    );
    setCompressionType(connectionDetails?.ZIP || "ZIP");
    setCustomHeaders(connectionDetails?.HTTP_CUSTOM_HEADER_FIELDS || "");
    setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || "");
    setShowDestinationPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
    setDestinationPassword(connectionDetails?.ZIP_PASSWORD ? decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2) : "");
    setContent({ ...connectionDetails });
  }, [connectionDetails]);

  useEffect(() => {
    if (!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
  }, [content]);

  const handleCancel = () => {
    // if (screen === "GET_DATA" || screen === "SEND_DATA") {
      setOpenModal(false);
      // return;
    // }

    // updateDetails();
  };
  const valuesHandler = (value) => {
    if (workflowMappings[valueLabel]) {
      const { stateSetter, key } = workflowMappings[valueLabel];
      if (key === "PASSWORD" || key === "ZIP_PASSWORD") {
        const encryptedValue =
          key === "PASSWORD" && !shouldEncryptDecryptPassword
            ? value
            : encryptString(value, process.env.REACT_APP_SECRET_KEY2);
        stateSetter(value);
        onInputChange(key, encryptedValue);
      } else {
        stateSetter(value);
        onInputChange(key, value);
      }
    }
  };
  const handleDone = (newData) => {
    if (screen === "GET_DATA" || screen === "SEND_DATA") {
      const encryptedVal = encryption({ HTTP_CUSTOM_HEADER_FIELDS: newData });
      onInputChange(
        "HTTP_CUSTOM_HEADER_FIELDS",
        newData.trim() === "" ? null : encryptedVal?.HTTP_CUSTOM_HEADER_FIELDS
      );
      setOpenModal(false);
      return;
    }

    // Update content state so Apply button has the latest data
    onInputChange("HTTP_CUSTOM_HEADER_FIELDS", newData);

    const body = {
      ...connectionDetails,
      connectionName,
      HTTP_CUSTOM_HEADER_FIELDS: newData,
      ADAPTER_TYPE: "HTTP",
    };
    dispatch(
      treeActions.setConnection({
        screen: "inbound",
        value: { connectionName, ...body },
      })
    );
    dispatch(
      api.endpoints.createPdc.initiate({
        account,
        direction: direction,
        name: encodeURIComponent(connectionName),
        body: encryption(body),
        oldPdcName: encodeURIComponent(connectionName),
      })
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS") {}
        // updateDetails();
      else
        setShowAlert({ mssg: res?.data?.message, isOpen: true, type: "error" });
    });
    setOpenModal(false);
  };

  const setHeaders = (val) => {
    setCustomHeaders(val);
  };

  const updateDetails = () => {
    dispatch(
      api.endpoints.getPdcDetail.initiate(
        {
          account,
          direction: direction,
          name: encodeURIComponent(connectionName),
        },
        { forceRefetch: true }
      )
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS" && res?.data?.data)
        setCustomHeaders(res.data?.data?.props?.HTTP_CUSTOM_HEADER_FIELDS);
      if (res?.data?.current_state === "ERROR")
        setShowAlert({ mssg: res.data.message, isOpen: true, type: "warning" });
    });
    setOpenModal(false);
  };

  const onInputChange = (name, value) => {
    if (["GET_DATA", "SEND_DATA"].includes(screen)) {
      setContent({ [name]: value });
      return;
    }
    setContent((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const debouncedContentUpdate = debounce(handleBodyContent, 400);

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  };
  const handleDecompressionChange = (checked) => {
    setDecompression(checked);

    if (checked) {
      onInputChange("ZIP", "ZIP");
    } 
    else {
      setShowDecompressionDir(false);
      setDecompressionDir("");
      setShowPassword(false);
      setPassword("");
      if(screen && screen === 'GET_DATA'){
        onInputChange('add',{ZIP: null, SPECIFY_DECOMPRESSION_DIRECTORY:'FALSE', DECOMPRESSION_DIRECTORY: null, USE_ZIP_PASSWORD:'FALSE',ZIP_PASSWORD: null})
      } else {
        onInputChange("ZIP", "");
        onInputChange("SPECIFY_DECOMPRESSION_DIRECTORY",stringifyJSONAttributes(false));
        onInputChange("DECOMPRESSION_DIRECTORY", "");
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", "");
      }
    }
  }
  const handleCompressionChange = (checked) => {
    setCompression(checked);
    if(checked){
      onInputChange("ZIP", "ZIP");
    }
    else{
      setCompressionType("ZIP");
      setFileNameZip("");
      setShowDestinationPassword(false);
      setDestinationPassword("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{ZIP: null, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null, FILE_NAME_WITHIN_ZIP: null})
      } else {
        onInputChange("ZIP", ""); 
        onInputChange("FILE_NAME_WITHIN_ZIP", "");
        onInputChange("ZIP_PASSWORD", "");
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
      }
    }
  }
  const handleCompressionTypeChange = (value) => {
    setCompressionType(value);
      if (["GZ", "TAR", "TGZ"].includes(value)) {
        setShowDestinationPassword(false);
        setDestinationPassword("");
        if (screen && screen === "SEND_DATA") {
          onInputChange("add", {
            ZIP: value,
            USE_ZIP_PASSWORD: "FALSE",
            ZIP_PASSWORD: null,
          });
        } else {
          onInputChange("ZIP", value);
          onInputChange("USE_ZIP_PASSWORD", stringifyJSONAttributes(false));
          onInputChange("ZIP_PASSWORD", "");
        }
      } else {
        onInputChange("ZIP", value);
      }
  }
  const getFontWeight = (control, currentValue, useConnection) => {
    if (!repoPDC) return "normal";
    return repoPDC?.[control] !== currentValue && useConnection === "preDefined"
      ? "bold"
      : "normal";
  };
  const fontWeights = useMemo(() => {
    return {
      url: getFontWeight("CONNECTIONSTRING", url, useConnection),
      privateKey: getFontWeight("KEY_ALIAS", privateKey, useConnection),
      keyAlias: getFontWeight("KEY_ALIAS", keyAlias, useConnection),
      username: getFontWeight("USERNAME", username, useConnection),
      password: getFontWeight("PASSWORD", password, useConnection),
      outTime: [600, "600"].includes(outTime)
        ? "normal"
        : getFontWeight("TIMEOUT", outTime, useConnection),
      sslVersion:
        sslVersion === t("SELECT")
          ? "normal"
          : getFontWeight("SSL_TYPE", sslVersion, useConnection),
      requestType: getFontWeight("REQUEST_TYPE", requestType, useConnection),
      contentType: getFontWeight("CONTENT_TYPE", contentType, useConnection),
      fileNameZip: getFontWeight("FILE_NAME_WITHIN_ZIP", fileNameZip, useConnection),
      decomPassword: getFontWeight(
        "ZIP_PASSWORD",
        decomPassword,
        useConnection
      ),
      destinationPassword: getFontWeight("ZIP_PASSWORD", destinationPassword, useConnection),
      decompressionDir: getFontWeight(
        "DECOMPRESSION_DIRECTORY",
        decompressionDir,
        useConnection
      ),
      customHeaders: getFontWeight(
        "HTTP_CUSTOM_HEADER_FIELDS",
        connectionDetails?.HTTP_CUSTOM_HEADER_FIELDS,
        useConnection
      ),
      compressionType: getFontWeight("COMPRESSION_TYPE", compressionType, useConnection)
    };
  }, [
    url,
    privateKey,
    username,
    password,
    outTime,
    sslVersion,
    decompressionDir,
    decomPassword,
    requestType,
    contentType,
    keyAlias,
    compressionType,
    fileNameZip,
    destinationPassword,
    connectionDetails?.HTTP_CUSTOM_HEADER_FIELDS,
    useConnection,
    repoPDC,
  ]);

  return (
    <>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_URL")}
            type="text"
            value={url}
            disabled={disableControl || false}
            onChange={(e) => {
              setUrl(e.target.value);
              onInputChange(e.target.name, e.target.value);
            }}
            inputProps={{
              style: { fontWeight: fontWeights.url },
            }}
            className={"width-100"}
            name={"CONNECTIONSTRING"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_URL"));
              setWorkflowSessionModal({
                open: true,
                isFirstTime: true,
              });
            }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      {direction === "IN" && (
        <div style={{ display: "flex", gap: "4px" }}>
          <Autocomplete
            disablePortal
            className="width-100"
            options={privateKeys}
            value={privateKey}
            disabled={disableControl || false}
            sx={{ maxHeight: 300 }}
            onChange={(event, value) => {
              onInputChange("KEY_ALIAS", value);
              setPrivateKey(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("LBL_KEY_ALIAS")}
                value={privateKey}
                inputProps={{
                  ...params.inputProps,
                  style: { fontWeight: fontWeights.privateKey },
                }}
                onChange={(e) => {
                  onInputChange("KEY_ALIAS", e.target.value);
                  setPrivateKey(e.target.value);
                }}
                variant="outlined"
                size="small"
                name={"KEY_ALIAS"}
                autoComplete="off"
              />
            )}
          />
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <Button
              size="small"
              disabled={disableControl || false}
              variant="outlined"
              onClick={() => {
                setValueLabel(t("LBL_KEY_ALIAS"));
                setWorkflowSessionModal({
                  open: true,
                  isFirstTime: true,
                });
              }}>
              <MoreHorizOutlined fontSize="small" />
            </Button>
          )}
        </div>
      )}
      {direction === "OUT" && (
        <>
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="requestTypeDropdownLabel">
              {t("LBL_REQUEST_TYPE")}
            </InputLabel>
            <Select
              className={"width-100"}
              disabled={disableControl || false}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"REQUEST_TYPE"}
              labelId="requestTypeDropdownLabel"
              label={t("LBL_REQUEST_TYPE")}
              id="requestTypeDropdown"
              value={requestType}
              sx={{
                "& .MuiSelect-select": { fontWeight: fontWeights.requestType },
              }}
              onChange={(e) => {
                if (e.target.value !== "-- Select --") {
                  onInputChange(e.target.name, e.target.value);
                }
                setRequestType(e.target.value);
              }}>
              <MenuItem value="-- Select --">-- Select --</MenuItem>
              {requestTypesDropDownItems}
            </Select>
          </FormControl>
          <Autocomplete
            disablePortal
            options={graphQLContentTypeOptions}
            value={contentType}
            disabled={disableControl || false}
            sx={{ maxHeight: 300 }}
            onChange={(e, value) => {
              onInputChange("CONTENT_TYPE", value);
              setContentType(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("LBL_CONTENT_TYPE")}
                value={contentType}
                inputProps={{
                  ...params.inputProps,
                  style: { fontWeight: fontWeights.contentType },
                }}
                onChange={(event, value) => {
                  onInputChange("CONTENT_TYPE", event.target.value);
                  setContentType(event.target.value);
                }}
                variant="outlined"
                size="small"
                name={"CONTENT_TYPE"}
                autoComplete="off"
              />
            )}
          />
          <div style={{ display: "flex", gap: "4px" }}>
            <Autocomplete
              disablePortal
              className="width-100"
              options={keyAliases}
              value={keyAlias}
              disabled={disableControl || false}
              sx={{ maxHeight: 300 }}
              onChange={(e, value) => {
                onInputChange("KEY_ALIAS", value);
                setKeyAlias(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("LBL_KEY_ALIAS_TO_USE")}
                  value={keyAlias}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontWeight: fontWeights.keyAlias },
                  }}
                  onChange={(event, value) => {
                    onInputChange("KEY_ALIAS", event.target.value);
                    setKeyAlias(event.target.value);
                  }}
                  variant="outlined"
                  size="small"
                  name={"KEY_ALIAS"}
                  autoComplete="off"
                />
              )}
            />
            {["GET_DATA", "SEND_DATA"].includes(screen) && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_KEY_ALIAS_TO_USE"));
                  setWorkflowSessionModal({
                    open: true,
                    isFirstTime: true,
                  });
                }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
        </>
      )}
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_USERNAME")}
            type="text"
            value={username || ""}
            disabled={disableControl || false}
            inputProps={{
              style: { fontWeight: fontWeights.username },
            }}
            onChange={(e) => {
              onInputChange("USERNAME", e.target.value);
              setUsername(e.target.value);
            }}
            className={"width-100"}
            name={"USER_NAME"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_USERNAME"));
              setWorkflowSessionModal({
                open: true,
                isFirstTime: true,
              });
            }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <SmartPasswordField
          variant="outlined"
          size="small"
          label={t("LBL_WS_PASSWORD")}
          value={password || ""}
          disabled={disableControl || false}
          inputProps={{
            style: { fontWeight: fontWeights.password },
          }}
          onChange={(e) => {
            onInputChange(
              "PASSWORD",
              shouldEncryptDecryptPassword
                ? encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2)
                : e.target.value
            );
            setPassword(e.target.value);
          }}
          className={"width-100"}
          name={"PASS_WORD"}
          autoComplete="off"
        />
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_WS_PASSWORD"));
              setWorkflowSessionModal({
                open: true,
                isFirstTime: true,
              });
            }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <FormControl className="width-100" size="small">
        <TextField
          variant="outlined"
          size="small"
          label={t("LBL_TIMEOUT")}
          type="text"
          value={outTime}
          disabled={disableControl || false}
          inputProps={{
            style: { fontWeight: fontWeights.outTime },
          }}
          onChange={(e) => {
            const inputValue = e.target.value;
            const numericValue = inputValue.replace(/\D/g, "");
            if (numericValue.length <= 9) {
              setOutTime(numericValue);
              onInputChange(e.target.name, numericValue);
            }
          }}
          className={"width-100"}
          name={"TIMEOUT"}
          autoComplete="off"
        />
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="sslTypeDropdownLabel">{t("LBL_SSL_TYPE")}</InputLabel>
        <Select
          className={"width-100"}
          disabled={disableControl || false}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name={"SSL_TYPE"}
          labelId="sslTypeDropdownLabel"
          label={t("LBL_SSL_TYPE")}
          id="sslTypeDropdown"
          value={sslVersion || ""}
          sx={{
            "& .MuiSelect-select": { fontWeight: fontWeights.sslVersion },
          }}
          onChange={(e) => {
            onInputChange(e.target.name, e.target.value);
            setSslVersion(e.target.value);
          }}>
          {sslVersionsTypeOptions.map((obj, key) => (
            <MenuItem key={key} value={obj}>
              {obj}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        className="width-100"
        size="small"
        disabled={disableControl || false}
        onClick={() => {
          if (
            !connectionDetails?.HTTP_CUSTOM_HEADER_FIELDS &&
            connection?.ADAPTER_TYPE === "GraphQL" &&
            connectionName === connection?.connectionName
          )
            setCustomHeaders(connection?.HTTP_CUSTOM_HEADER_FIELDS || "");
          setOpenModal(true);
        }}
        variant="outlined"
        sx={{
          fontWeight: fontWeights.customHeaders,
          color: fontWeights.customHeaders === "bold" ? "#000" : "inherit",
        }}>
        <span
          style={{
            fontWeight: fontWeights.customHeaders,
            color: fontWeights.customHeaders === "bold" ? "#000" : "inherit",
          }}>
          {t("LBL_HTTP_CUSTOM_HEADER_FIELDS")}{" "}
          {`${
            customHeaders &&
            encodeURIComponent(customHeaders) !== "%1F"
              ? `(${t("SET")})`
              : ""
          }`}
        </span>
      </Button>
      <div className="flex flex-wrap">
        <TPCheckbox
          label={t("BTN_FORCE_HOST_VERIFICATION")}
          checked={sslHost}
          disabled={disableControl || false}
          handleCheck={(checked) => {
            onInputChange(
              "FORCE_HOST_VERIFICATION",
              stringifyJSONAttributes(checked)
            );
            setSslHost(checked);
          }}
        />
        <TPCheckbox
          label={
            direction === "IN"
              ? t("BTN_SEND_SYNC_RESPONSE")
              : t("BTN_RECEIVE_SYNC_RESPONSE")
          }
          checked={syncResponse}
          disabled={disableControl || false}
          handleCheck={(checked) => {
            onInputChange("SYNCHRONOUS", stringifyJSONAttributes(checked));
            setSyncResponse(checked);
          }}
        />
      </div>
      <div className="flex flex-wrap">
        {direction === "IN" && (
          <TPCheckbox
            label={t("BTN_USE_ZIP_DECOMPRESS")}
            checked={decompression}
            disabled={disableControl || false}
            handleCheck={(checked) => {
              handleDecompressionChange(checked);
            }}
          />
        )}
        {direction === "OUT" && (
          <TPCheckbox
            label={t("BTN_USE_ZIP_COMPRESS")}
            checked={compression}
            disabled={disableControl || false}
            handleCheck={(checked) => {
              handleCompressionChange(checked);
            }}
          />
        )}
        <TPCheckbox
          label={t("BTN_URLENCODE")}
          checked={urlEncode}
          disabled={disableControl || false}
          handleCheck={(checked) => {
            onInputChange("URLENCODE", stringifyJSONAttributes(checked));
            setUrlEncode(checked);
          }}
        />
      </div>
      {decompression && direction === "IN" && (
        <>
          <div>
            <TPCheckbox
              label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
              checked={showDecompressionDir}
              disabled={disableControl || false}
              handleCheck={(checked) => {
                setShowDecompressionDir(checked);
                if (!checked) {
                  onInputChange("DECOMPRESSION_DIRECTORY", "");
                  setDecompressionDir("");
                }
              }}
            />
          </div>
          {showDecompressionDir && (
            <div style={{ display: "flex", gap: "4px" }}>
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_DECOMPRESS_DIRECTORY")}
                  type="text"
                  value={decompressionDir || ""}
                  disabled={disableControl || false}
                  inputProps={{
                    style: { fontWeight: fontWeights.decompressionDir },
                  }}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setDecompressionDir(e.target.value);
                  }}
                  className={"width-100"}
                  name={"DECOMPRESSION_DIRECTORY"}
                  autoComplete="off"
                />
              </FormControl>
              {["GET_DATA", "SEND_DATA"].includes(screen) && (
                <Button
                  size="small"
                  disabled={disableControl || false}
                  variant="outlined"
                  onClick={() => {
                    setValueLabel(t("LBL_DECOMPRESS_DIRECTORY"));
                    setWorkflowSessionModal({
                      open: true,
                      isFirstTime: true,
                    });
                  }}>
                  <MoreHorizOutlined fontSize="small" />
                </Button>
              )}
            </div>
          )}
          <div>
            <TPCheckbox
              label={t("LBL_WS_PASSWORD")}
              checked={showPassword}
              disabled={disableControl || false}
              handleCheck={(checked) => {
                onInputChange(
                  "USE_ZIP_PASSWORD",
                  stringifyJSONAttributes(checked)
                );
                setShowPassword(checked);
                if (!checked) {
                  setDecomPassword("");
                  onInputChange("ZIP_PASSWORD", "");
                }
              }}
            />
          </div>
          {showPassword && (
            <div style={{ display: "flex", gap: "4px" }}>
              <SmartPasswordField
                variant="outlined"
                size="small"
                label={t("LBL_WS_PASSWORD")}
                value={decomPassword || ""}
                disabled={disableControl || false}
                inputProps={{
                  style: { fontWeight: fontWeights.decomPassword },
                }}
                onChange={(e) => {
                  onInputChange(
                    e.target.name,
                    encryptString(
                      e.target.value,
                      process.env.REACT_APP_SECRET_KEY2
                    )
                  );
                  setDecomPassword(e.target.value);
                }}
                className={"width-100"}
                name={"ZIP_PASSWORD"}
                autoComplete="off"
              />
              {["GET_DATA", "SEND_DATA"].includes(screen) && (
                <Button
                  size="small"
                  disabled={disableControl || false}
                  variant="outlined"
                  onClick={() => {
                    setValueLabel(t("LBL_ZIP_PASSWORD"));
                    setWorkflowSessionModal({
                      open: true,
                      isFirstTime: true,
                    });
                  }}>
                  <MoreHorizOutlined fontSize="small" />
                </Button>
              )}
            </div>
          )}
        </>
      )}
      {compression && direction === "OUT" && (
        <>
          <Autocomplete
            disablePortal
            options={compressionList}
            getOptionLabel={(option) => option}
            value={compressionType}
            disabled={disableControl || false}
            sx={{ maxHeight: 300 }}
            onChange={(e, value) => {
              handleCompressionTypeChange(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("LBL_COMPRESSION_TYPE")}
                inputProps={{
                  ...params.inputProps,
                  style: { fontWeight: fontWeights.compressionType },
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  handleCompressionTypeChange(value);
                }}
                variant="outlined"
                size="small"
                name={"ZIP"}
                autoComplete="off"
              />
            )}
          />
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("FILE_NAME_WITHIN_ZIP")}
                type="text"
                value={fileNameZip || ""}
                disabled={disableControl || false}
                inputProps={{
                  style: { fontWeight: fontWeights.fileNameZip },
                }}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setFileNameZip(e.target.value);
                }}
                className={"width-100"}
                name={"FILE_NAME_WITHIN_ZIP"}
                autoComplete="off"
              />
            </FormControl>
            {["GET_DATA", "SEND_DATA"].includes(screen) && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("FILE_NAME_WITHIN_ZIP"));
                  setWorkflowSessionModal({
                    open: true,
                    isFirstTime: true,
                  });
                }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          {["JAR", "RAR", "ZIP"].includes(compressionType) && (
            <>
              <div>
                <TPCheckbox
                  label={t("LBL_WS_PASSWORD")}
                  checked={showDestinationPassword}
                  disabled={disableControl || false}
                  handleCheck={(checked) => {
                    onInputChange(
                      "USE_ZIP_PASSWORD",
                      stringifyJSONAttributes(checked)
                    );
                    setShowDestinationPassword(checked);
                    if (!checked) {
                      onInputChange("ZIP_PASSWORD", "");
                      setDestinationPassword("");
                    }
                  }}
                />
              </div>
              {showDestinationPassword && (
                <div style={{ display: "flex", gap: "4px" }}>
                  <SmartPasswordField
                    variant="outlined"
                    size="small"
                    type="password"
                    label={t("LBL_WS_PASSWORD")}
                    value={destinationPassword || ""}
                    disabled={disableControl || false}
                    inputProps={{
                      style: { fontWeight: fontWeights.destinationPassword },
                    }}
                    onChange={(e) => {
                      onInputChange(
                        e.target.name,
                        encryptString(
                          e.target.value,
                          process.env.REACT_APP_SECRET_KEY2
                        )
                      );
                      setDestinationPassword(e.target.value);
                    }}
                    className={"width-100"}
                    name={"ZIP_PASSWORD"}
                    autoComplete="off"
                  />
                  {["GET_DATA", "SEND_DATA"].includes(screen) && (
                    <Button
                      size="small"
                      disabled={disableControl || false}
                      variant="outlined"
                      onClick={() => {
                        setValueLabel(t("LBL_ZIP_PASSWORD") + "_DEST");
                        setWorkflowSessionModal({
                          open: true,
                          isFirstTime: true,
                        });
                      }}>
                      <MoreHorizOutlined fontSize="small" />
                    </Button>
                  )}
                </div>
              )}
            </>
          )}
        </>
      )}
      {openModal && (
        <CustomHeaders
          setOpenModal={setOpenModal}
          handleCancel={handleCancel}
          handleDone={handleDone}
          openModal={openModal}
          customHeaders={customHeaders}
          setCustomHeaders={setHeaders}
        />
      )}

      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>

      <WorkflowSessionModal
        valueLabel={valueLabel}
        showAccountData={true}
        showCallingWorkflow={true}
        showSystemData={true}
        showWorkflowSession={true}
        showDateAndTime={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={workflowMappings[valueLabel]?.value}
        valuesHandler={(value) => {
          valuesHandler(value);
        }}
        inputType={
          valueLabel === t("LBL_WS_PASSWORD") ||
          valueLabel === t("LBL_PASSWORD") ||
          valueLabel === t("LBL_ZIP_PASSWORD") ||
          valueLabel === t("LBL_ZIP_PASSWORD") + "_DEST"
            ? "password"
            : "text"
        }
        specialPasswordField={
          valueLabel === t("LBL_WS_PASSWORD") ||
          valueLabel === t("LBL_PASSWORD")
        }
      />
    </>
  );
}

export default GraphQL;
